import React, { CSSProperties } from 'react';

const KariusMobile = React.forwardRef<HTMLDivElement, { style?: CSSProperties; className?: string }>((props, ref) => {
  return (
    <div ref={ref} {...props}>
      <svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M26.4307 1.07419C25.3805 0.0800312 23.5766 0.136948 22.5894 1.19371L9.43507 15.295V3.07009C9.43507 2.34425 9.14876 1.64814 8.63912 1.1349C8.12949 0.621651 7.43827 0.333313 6.71754 0.333313C5.9968 0.333313 5.30558 0.621651 4.79595 1.1349C4.28631 1.64814 4 2.34425 4 3.07009V28.8413C4 29.5671 4.28631 30.2632 4.79595 30.7765C5.30558 31.2897 5.9968 31.5781 6.71754 31.5781C7.43827 31.5781 8.12949 31.2897 8.63912 30.7765C9.14876 30.2632 9.43507 29.5671 9.43507 28.8413V23.2899L26.5522 4.94456C27.0426 4.41353 27.3049 3.709 27.2822 2.9842C27.2594 2.25939 26.9534 1.57296 26.4307 1.07419'
          fill='white'
        />
        <path
          d='M27.1984 26.9431L20.6669 20.2079C19.642 19.1644 17.8533 19.1644 16.8199 20.1927C16.3096 20.704 16.0213 21.3981 16.0181 22.123C16.0149 22.8479 16.2972 23.5445 16.803 24.0603L23.278 30.7433C23.5231 31.012 23.819 31.2286 24.1484 31.3805C24.4777 31.5324 24.8339 31.6164 25.196 31.6278C25.5581 31.6391 25.9188 31.5775 26.2569 31.4465C26.595 31.3155 26.9037 31.1178 27.1649 30.865C27.4261 30.6122 27.6345 30.3094 27.7779 29.9744C27.9213 29.6393 27.9967 29.2788 27.9998 28.914C28.003 28.5492 27.9337 28.1874 27.796 27.85C27.6584 27.5125 27.4552 27.2061 27.1984 26.9488'
          fill='white'
        />
      </svg>
    </div>
  );
});

KariusMobile.displayName = 'KariusMobile';

export default KariusMobile;
